import "./Hero.css";
import { useT } from "@/i18n/context";
import { company } from "@/data/company";
import penguinMark from "@/assets/penguin-mark.svg";

export function Hero() {
  const t = useT();
  return (
    <section id="top" className="hero">
      <div className="container">
        <div className="hero__layout">
          <div className="hero__inner">
            <h1 className="hero__title">{t.hero.title}</h1>
            <p className="hero__subtitle">{t.hero.subtitle}</p>
            <div className="hero__actions">
              <a className="btn hero__cta" href={`mailto:${company.email}`}>
                {t.hero.cta}
              </a>
            </div>
          </div>
          <div className="hero__mark" aria-hidden="true">
            <img src={penguinMark} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
